var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4280,
    height: 2800,
    viewBox: "0 0 4280 2800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4280,
    height: 2800,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2,
    clipPath: "url(#clip0_0_1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2712.9 2138.75V1999.09V1868.86V1731.1V1731H2545V1731.1V1748.34V2410.52H2712.9V2270.86H3204.32V2138.75H2712.9Z",
    fill: "#DEDC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2403.93 2616.18V2615.21V2613.82V2613.03V2341H2063L2063 2613.82V2614.95V2615.51V2616.63V2634.78V2635.72L2063 2646H2404.06L2403.93 2616.18Z",
    fill: "#E18700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2469.06 2041H2240.02H1914V2192H2063V2341H2403.87V2192H2545V2141.36V2127.33V2041H2469.06Z",
    fill: "#94C11F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2648.94 1591H2877.98H3204V1440H3055V1291H2714.13V1440H2573V1490.64V1504.67V1591H2648.94Z",
    fill: "#191160"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3357 2645V2497H2951V2645H3221V2800H3561.87H3581V2645H3491.5H3435H3387H3357Z",
    fill: "#662383"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4124.5 2043.5H4280V1631H4126.63V1901H3966V2241.87V2261H4124.5V2172V2117V2070V2043.5Z",
    fill: "#662383"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2369.17 1175.06V1261.44H2140V1176.24H2290V1087H2479.37H2490V1175.06H2440.56H2410H2383.89H2369.17Z",
    fill: "#662383"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3644.66 699.298H3817V1174H3647.02V863.286H3469V471.013V449H3644.66V551.421V614.714V668.802V699.298Z",
    fill: "#E9D0F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1913.96 2650H1756.5H1610H1454V2652V2800H1454.5H1473.5H2220.53V2644.76H2062.99V2191H1913.96V2650Z",
    fill: "#E71E73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M708.312 1120.04V980.381V850.155V712.393V712.29H876.212V712.393V729.634V1391.81H708.312V1252.15H216.896L216.896 1120.04H708.312Z",
    fill: "#E71E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3524.9 1399.77V1539.42V1669.65V1807.41V1807.52H3357V1807.41V1790.17V1128H3524.9V1267.66H4016.32V1399.77H3524.9Z",
    fill: "#E71E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M700.719 2799.64V2800H1454V2650H1299.82V2189H864.1V2670.95H690.18V2676.42V2701.57L690 2799.64H700.719Z",
    fill: "#DEDC00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M864.595 2629.29V2628.5V1995H691.151V2131.42H176V2536.3H689.464V2671H690.079H690.745L865 2670.85L864.595 2629.29Z",
    fill: "#94C11F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3643.41 41.7076H3643V676L3817.1 676V539.576H4333V134.698L3820.43 134.698V0.147658L3817.51 0.147658V0L3643 0.147658L3643.41 41.7076Z",
    fill: "#94C11F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M690 2670H174V2800L690 2798.7V2670Z",
    fill: "#F39200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1299 1628V2575H1454V1628H1299Z",
    fill: "#F39200"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2404 2191V2800H2545V2191H2404Z",
    fill: "#662383"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3412 923H2708V1052L3412 1050.71V923Z",
    fill: "#662383"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2573 -5.24521e-06V704H2702L2700.71 -5.24521e-06H2573Z",
    fill: "#F6E1FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3837 1441V2145H3966L3964.71 1441H3837Z",
    fill: "#DEDC00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.747 2797.87H176.156V2670.7H690.125V2535.57H176.156V2136.85V2133.58V2131.39H0.394188V2798.62H0V2799.71H175.747V2797.87Z",
    fill: "#37AAE1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1620.07 1754.23V1754.58L1763.53 1754.23V2191H1914V1754.58L2372.09 1754.23V1754.58H2373.13V1605.33H1619.23V1605H1618V1754.23H1620.07Z",
    fill: "#37AAE1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4124.35 2048V2057.5V2189L4125 2645H3581V2800H3837.17H4118H4121.5H4123.5H4280V2046V2044.5V2043.5H4124.35V2048Z",
    fill: "#37AAE1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1880.46 678.56V677.458V675.893V674.993V367.29H1535.53L1535.53 675.893V677.163V677.798V679.068V699.602V700.664L1535.53 712.29H1880.59L1880.46 678.56Z",
    fill: "#F39200"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4180.9 1002.56V1001.76V1000.63V999.973V777H3931L3931 1000.63V1001.55V1002.01V1002.93V1017.81V1018.58L3931 1027H4181L4180.9 1002.56Z",
    fill: "#F39200"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4124.85 2607.46V2606.23V2604.49V2603.49L4125 2261H3741L3741 2604.49V2605.9V2606.61V2608.02V2630.88V2632.06L3741 2645H4125L4124.85 2607.46Z",
    fill: "#94C11F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3741 2607.3L3741 2606.3L3741 2604.29L3741 2603.28L3741 2261H3357L3357 2604.49V2605.9V2606.61V2608.02V2630.88V2632.06L3357 2645H3741L3741 2607.3Z",
    fill: "#B36B00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M635.736 1833.66V1832.32V1830.42V1829.33V1455.17H216.896L216.896 1830.42V1831.96V1832.74V1834.28V1859.25V1860.54L216.897 1874.68H635.896L635.736 1833.66Z",
    fill: "#662383"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1914 2605.16L1914 2603.57V2601.46L1914 2600.41V2191H1454L1454 2601.58V2603.27V2604.11V2605.8V2633.12V2634.53V2650H1914V2605.16Z",
    fill: "#662383"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.37 1783.48H1121V1117H1274.99L1275.36 1370.2H1514.65V1522.6H1274.99V1792.8H1275.36V1792.96H1121.37V1783.48Z",
    fill: "#DEDC00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2875.48 76.3735V75.9999L3541.96 75.9999V229.995L3288.77 230.355V469.648H3136.37V229.995L2866.16 229.995V230.355H2866V76.3735H2875.48Z",
    fill: "#DEDC00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3356.66 1530.45H3357V2123.96H3215.78L3215.45 1898.48H2996V1762.77H3215.78V1522.14H3215.45V1522H3356.66V1530.45Z",
    fill: "#37AAE1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3212.5 2799.65H3211.48L2545 2800V2645.65L2780.5 2645V2497H2965V2645H3217.5H3220H3221L3220.96 2799.65H3212.5Z",
    fill: "#E71E73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4280,
    height: 2800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundHome);
export default __webpack_public_path__ + "static/media/background-home.899b3345a1974bbbc0c3721f91236181.svg";
export { ForwardRef as ReactComponent };